module.exports = __webpack_public_path__ + "static/media/No-documents-found.5f48025e.gif";